import { ViewController, TitlebarView } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class TitlebarController extends ViewController {
    public name: string;
    titlebar: TitlebarView;

    constructor( options ) {
        options = options || {};
        options.view = options.titlebar || null;
        super( options );
        this.name = 'titlebarController';

        this.titlebar = options.titlebar || null;
    }

    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        this.titlebar.setTitle(
            __('Season') + ' ' + event.season.nr,
            __('Matchday') + ' ' + event.matchday.nr
        );
    }

    handleTimeoutEvent( event, provider ) {
        this.titlebar.deactivate( event );
    }
}